import React from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import { useCounterpartyNameMap } from "@components/counterparty/useCounterpartyNameMap";
import { SpreadsheetGrid } from "@components/spreadsheet/SpreadsheetGrid";
import { CashItemImporterRow } from "./cashItemImporterRows";
import { InvalidCellsByRowId } from "./cashItemImportValidation";
import { useCashItemImporterChangeHandler } from "./useCashItemImporterChangeHandler";
import { useCashItemImporterColumns } from "./useCashItemImporterColumns";
import styles from "./CashItemImporter.module.scss";

interface Props {
    rows: CashItemImporterRow[];
    setRows: React.Dispatch<React.SetStateAction<CashItemImporterRow[]>>;
    financialAccountsById: ReadonlyMap<number, FinancialAccount>;
    invalidCellsByRowId: InvalidCellsByRowId;
}

export const CashItemImporterSpreadsheet: React.FC<Props> = ({
    rows,
    setRows,
    financialAccountsById,
    invalidCellsByRowId,
}) => {
    const counterpartiesMap = useCounterpartyNameMap();

    const columns = useCashItemImporterColumns({
        counterpartiesMap,
        financialAccountsById,
        invalidCellsByRowId,
    });
    const handleChange = useCashItemImporterChangeHandler({
        setRows,
        financialAccountsById,
    });

    return (
        <SpreadsheetGrid
            className={styles.grid}
            data={rows}
            columns={columns}
            onChange={handleChange}
            minSpareRows={30}
            noOuterBorder
            stickyHeader
            showTotalsRow
            overflow="auto"
            lightNotEditableCells
        />
    );
};
